// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"94d726ef","268":"c8b7e4f9","496":"b306bdeb"}[chunkId] + ".chunk.js";
};